import { breadcrumb } from './breadcrumb';

export const mailer = {
  breadcrumb,

  mailing: {
    new_status: {
      moderation: 'Proses moderasi',
      rejected: 'Ditolak',
      pending: 'Pending',
      processing: 'Proses',
      processed: 'Diproses',
      finished: 'Selesai',
      failed: 'Gagal',
    },

    modal: {
      remove: {
        content: 'Anda yakin akan menghapus {name} daftar pesan?'
      },
      view: {
        title: 'Bagian pesan'
      },
      part_number: 'Bagian dari pesan',
      status: 'Status',
      client_cost: 'Harga'
    },

    form: {
      block: {
        sender: {
          title: 'Pengirim'
        },

        content: {
          title: 'Isi konten'
        },

        recipients: {
          title: 'Penerima'
        },

        sms: {
          placeholder: 'Pesan Anda'
        },

        date: {
          title: 'Tanggal pengiriman',
          action: 'Pesan tertunda'
        }
      },

      field: {
        sender: {
          title: 'Nama'
        },

        title: {
          title: 'Judul',
          placeholder: 'Masukan judul'
        },

        template: {
          title: 'Template',
          save_template: 'Simpan Template'
        },

        macros: {
          title: 'Makro'
        },

        body: {
          title: 'Bodi'
        }
      }
    }
  },

  message: {
    field: {
      src: 'Nomor pengirim Virtual',
      dst: 'Nomor Penerima',
      created_at: 'Tanggal penerimaan',
      body: 'Pesan text',
      parts: 'Bagian',
      name: 'Nama buletin',
      source_type: 'Sumber',
      total_parts: 'Jumlah bagian',
      sender_name: 'Nama pengirim'
    },

    noty: {
      balance:
        'Dana di akun tidak mencukupi. Pengiriman SMS dijeda. Silahkan lakukan pembayaran ke rekening Anda.'
    },

    setting: {
      title: 'Settings',
      field: {
        webhook_sms_state: {
          name: 'Posting kembali status SMS'
        },
        webhook_incoming_sms: {
          name: 'Webhook incoming SMS',
          description:
            'Masukkan URL Anda dan kami akan dapat mengirimkan data kepada Anda melalui SMS yang masuk.',
          requirement:
            'Persyaratan: URL ini harus dapat diakses melalui permintaan POST dan berikan status - 200. Format data: json. Contoh {"src":"89876543210", "dst": "80123456789", "body": "sms text"}'
        }
      }
    },

    status: {
      delivered: 'Terkirim',
      sent: 'Terkirim',
      pending: 'Tertunda',
      not_delivered: 'Tidak Terkirim',
      failed: 'Gagal',
      rejected: 'Ditolak',
      expired: 'Kedaluwarsa',
      processing: 'Обработка'
    },

    status_table: {
      sent: 'Terkirim',
      pending: 'Tertunda',
      delivered: 'Terkirim',
      active: 'Aktif',
      not_delivered: 'Tidak Terkirim',
      failed: 'Gagal',
      error: 'Kesalahan',
      rejected: 'Ditolak',
      processing: 'Proses',
      resending: 'Kirim ulang',
      expired: 'Kedaluwarsa'
    }
  },

  template: {
    fields: {
      body: 'Bodi'
    },

    modal: {
      remove: {
        content: 'Anda yakin ingin menghapus template {name}?'
      }
    }
  },

  buttons: {
    add_senders: 'Tambahkan pengirim'
  },

  sender: {
    state: {
      all: 'Semua',
      moderation: 'Moderasi',
      canceled: 'Ditolak',
      active: 'Aktif',
      deactivated: 'Dinonaktifkan',
      new: 'Baru',
      on_deactivation: 'Pada penonaktifan'
    },

    table: {
      name: 'Nama pengirim',
      description: 'Keterangan',
      cost: 'Harga',
      deactivate: 'Menonaktifkan'
    },

    form: {
      create: {
        description:
          'Nama pengirim dapat berisi hingga 11 huruf Latin, angka, dan karakter khusus(.,-_).'
      }
    },

    modal: {
      add: {
        title: 'Tambahkan pengirim',
        description:
          'Setelah mengirimkan permintaan untuk menambahkan Pengirim, Anda akan melihat di kolom Deskripsi daftar dokumen yang diperlukan untuk pendaftaran dan biaya bulanan Pengirim.',
        sender_name: 'Nama pengirim'
      },
      remove: {
        content: 'Apakah Anda yakin ingin menghapus pengirimnya {name}?'
      },
      deactivate: {
        content: 'Apakah Anda yakin ingin menonaktifkan {name}?'
      }
    }
  },

  tooltips: {
    delayed_until: 'Waktu dalam UTC pengguna',
    db_range: 'Menentukan kisaran angka yang akan disertakan dalam buletin'
  },

  archived_stats: {
    general: {
      filter: {
        group_by: {
          title: 'Dikelompokan',
          values: {
            day: 'Day',
            mailing: 'Pesan',
            country: 'Negara',
            operator: 'Operator',
            sender: 'Sender'
          }
        }
      }
    }
  },

  stats: {
    general: {
      filter: {
        group_by: {
          title: 'Dikelompokan',
          values: {
            day: 'Day',
            mailing: 'Pesan',
            country: 'Negara',
            sender: 'Sender',
            network: 'Operator'
          }
        },

        sender: {
          title: 'Sender'
        },

        source: {
          title: 'Sumber',
          values: {
            web: 'Web interface',
            api: 'API'
          }
        }
      },

      field: {
        total: 'Total',
        cost: 'Cost',
        group: 'Date'
      },

      block: {
        main: 'Tabel Kesimpulan'
      }
    },

    detailed: {
      filter: {
        number: {
          title: 'Nomor'
        },
        status: {
          title: 'Status'
        },
        mailing: {
          title: 'Penyuratan'
        }
      },
      total: 'Jumlah elemen '
    }
  },
  not_sender: {
    not_sender: 'Anda tidak memiliki ID Pengirim yang disetujui.',
    to_create: 'Untuk membuat surat baru, harap ikuti',
    link: 'link',
    and_to_create: 'dan buatlah ID pengirim baru'
  },

  export: {
    not_export: 'Tidak ada data untuk diekspor. Coba ubah kondisi filter.'
  }
};
